import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Box, IconButton, TextField, Card } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import NoDataFound from 'common/component/NoDataFound';
import MDButton from 'components/MDButton';
import { Icon } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditableAccordionHeader from '../components/EditableAccordionHeader';
function FavDeliverySection({
  deliveryOpen,
  setDeliveryOpen,
  formData,
  setFormData,
  errors,
  setErrors,
  isDefaultHomePage,
  stateName,
  handleRemoveDelivery,
  handleFileChange,
  handleDelivery,
  updateDeliveryField,
  // Heading editing props
  sectionHeading,
  isEditingHeading,
  tempHeadingValue,
  setTempHeadingValue,
  onEditHeading,
  onSaveHeading,
  onCancelHeading,
}) {
  return (
    <Accordion expanded={deliveryOpen} onChange={() => setDeliveryOpen(!deliveryOpen)}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panelCaliforniaFavoriteCannabisDelivery-content"
      id="panelCaliforniaFavoriteCannabisDelivery-header"
    >
      <EditableAccordionHeader
        sectionKey="deliverySection"
        heading={sectionHeading}
        isEditing={isEditingHeading}
        tempValue={tempHeadingValue}
        setTempValue={setTempHeadingValue}
        onEdit={onEditHeading}
        onSave={onSaveHeading}
        onCancel={onCancelHeading}
      />
    </AccordionSummary>
    <AccordionDetails>
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="body2"
            fontWeight="medium"
            color="#9A9AAF"
            mb={1}
            name="deliverySectionTitle"
            style={{ fontSize: "14px" }}
          >
            Section Title (H2)
          </Typography>
          <TextField
            label=""
            className="form-input"
            fullWidth
            name="deliverySectionTitle"
            placeholder=""
            value={formData?.deliverySection?.sectionTitle}
            error={Boolean(errors?.deliverySectionTitle)}
            helperText={errors?.deliverySectionTitle}
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, deliverySectionTitle: "" }));
              setFormData((prev) => ({
                ...prev,
                deliverySection: {
                  ...prev?.deliverySection,
                  sectionTitle: e.target.value,
                },
              }));
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography
            variant="body2"
            fontWeight="medium"
            color="#9A9AAF"
            mb={1}
            name="deliverySectionPara"
            style={{ fontSize: "14px" }}
          >
            Paragraph (P)
          </Typography>
          <TextField
            label=""
            className="form-input"
            fullWidth
            placeholder=""
            name="deliverySectionPara"
            value={formData?.deliverySection?.sectionPara}
            error={Boolean(errors?.deliverySectionPara)}
            helperText={errors?.deliverySectionPara}
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, deliverySectionPara: "" }));
              setFormData((prev) => ({
                ...prev,
                deliverySection: {
                  ...prev?.deliverySection,
                  sectionPara: e.target.value,
                },
              }));
            }}
          />
        </Grid>

        {formData?.deliverySection?.subData?.length === 0 && (
          <Grid item xs={12}>
            <Box
              sx={{
                mt: 8,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <NoDataFound />
            </Box>
          </Grid>
        )}
        {formData?.deliverySection?.subData?.map((item) => (
          <Grid item xs={12} md={12} key={item.deliveryId}>
            <Card
              sx={{
                p: { xs: 2, md: 3 },
                borderRadius: 2.5,
                boxShadow: "none",
                backgroundColor: "#F5F5FF",
                position: "relative",
              }}
            >
              <Typography
                variant="body2"
                fontWeight="medium"
                color="#9A9AAF"
                mb={1}
                style={{ fontSize: "14px" }}
              >
                {item.image ? "Change Icon" : "Add Icon"}
              </Typography>
              {formData.deliverySection.subData.length >= 1 && (
                <IconButton
                  onClick={() => handleRemoveDelivery(item.deliveryId)}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    zIndex: 1,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 1)",
                    },
                  }}
                  color="error"
                  size="small"
                >
                  <DeleteIcon width="16px" height="16px" />
                </IconButton>
              )}

              <Grid container direction="row" spacing={4} key={item.deliveryId}>
                <Grid item xs={12} md={12}>
                  <input
                    type="file"
                    id={`file-input-${item.deliveryId}`}
                    style={{ display: "none" }}
                    accept="image/*"
                    name={[`deliverySubData_${item.deliveryId}_image`]}
                    onChange={(e) => {
                      setErrors((prev) => ({
                        ...prev,
                        [`deliverySubData_${item.deliveryId}_image`]: "",
                      }));
                      handleFileChange(e, item.deliveryId);
                    }}
                  />
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="16px"
                    backgroundColor="#ffffff"
                    width="110px"
                    height="110px"
                    overflow="hidden"
                    sx={{
                      border: errors[`deliverySubData_${item.deliveryId}_image`]
                        ? "1px solid red"
                        : "none",
                    }}
                  >
                    <MDButton
                      sx={{
                        minWidth: "100%",
                      }}
                      type="button"
                      variant="outlined"
                      color="secondary"
                      component="span"
                      onClick={() =>
                        document.getElementById(`file-input-${item.deliveryId}`).click()
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        padding: "0",
                        border: "none",
                        borderRadius: "0",
                      }}
                    >
                      <div className="add-change-img-sec">
                        {item.image ? (
                          <Box>
                            <img
                              src={item.image}
                              alt="preview"
                              style={{
                                width: "45px",
                                height: "45px",
                                objectFit: "contain",
                              }}
                            />
                            {/* <IconButton
                              className="remove-icon"
                              size="small"
                              onClick={(e) => {
                                handleRemoveImageDelivery(index);
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton> */}
                          </Box>
                        ) : (
                          <>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="25"
                              viewBox="0 0 24 25"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_13676_49992)">
                                <path
                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                  fill="#2E2E3A"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_13676_49992">
                                  <rect width="24" height="25" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            <Typography
                              variant="body2"
                              fontWeight="600"
                              color="#2E2E3A"
                              style={{ fontSize: "12px" }}
                            >
                              Upload File
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight="400"
                              color="#2E2E3A"
                              style={{ fontSize: "12px" }}
                            >
                              45x45
                            </Typography>
                          </>
                        )}
                      </div>
                    </MDButton>
                  </Box>
                  {/* {errors[`deliverySubData_${index}_image`] && (
                    <Typography color="error" sx={{ fontSize: "12px", mt: 1 }}>
                      {errors[`deliverySubData_${index}_image`]}
                    </Typography>
                  )} */}
                </Grid>

                {/* --- HEADING FIELD --- */}
                <Grid item xs={12} md={4}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    name={[`deliverySubData_${item.deliveryId}_heading`]}
                    style={{ fontSize: "14px" }}
                  >
                    Heading (H3)
                  </Typography>

                  <TextField
                    label=""
                    fullWidth
                    placeholder=""
                    value={item.heading}
                    error={Boolean(errors[`deliverySubData_${item.deliveryId}_heading`])}
                    name={`deliverySubData_${item.deliveryId}_heading`}
                    helperText={errors[`deliverySubData_${item.deliveryId}_heading`]}
                    onChange={(e) => {
                      setErrors((prev) => ({
                        ...prev,
                        [`deliverySubData_${item.deliveryId}_heading`]: "",
                      }));
                      updateDeliveryField(item.deliveryId, "heading", e.target.value);
                    }}
                  />
                </Grid>

                {/* --- SUB HEADING FIELD --- */}
                <Grid item xs={12} md={4}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    name={[`deliverySubData_${item.deliveryId}_subHeading`]}
                    style={{ fontSize: "14px" }}
                  >
                    Sub Heading (H4)
                  </Typography>

                  <TextField
                    label=""
                    fullWidth
                    className="form-input"
                    placeholder=""
                    value={item.subHeading}
                    name={`deliverySubData_${item.deliveryId}_subHeading`}
                    error={Boolean(errors[`deliverySubData_${item.deliveryId}_subHeading`])}
                    helperText={errors[`deliverySubData_${item.deliveryId}_subHeading`]}
                    onChange={(e) => {
                      setErrors((prev) => ({
                        ...prev,
                        [`deliverySubData_${item.deliveryId}_subHeading`]: "",
                      }));
                      updateDeliveryField(item.deliveryId, "subHeading", e.target.value);
                    }}
                  />
                </Grid>

                {/* --- PARAGRAPH FIELD --- */}
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    name={[`deliverySubData_${item.deliveryId}_paragraph`]}
                    style={{ fontSize: "14px" }}
                  >
                    Paragraph
                  </Typography>

                  <TextField
                    label=""
                    placeholder=""
                    className="form-input"
                    fullWidth
                    value={item.paragraph}
                    name={`deliverySubData_${item.deliveryId}_paragraph`}
                    error={Boolean(errors[`deliverySubData_${item.deliveryId}_paragraph`])}
                    helperText={errors[`deliverySubData_${item.deliveryId}_paragraph`]}
                    onChange={(e) => {
                      setErrors((prev) => ({
                        ...prev,
                        [`deliverySubData_${item.deliveryId}_paragraph`]: "",
                      }));
                      updateDeliveryField(item.deliveryId, "paragraph", e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>
        ))}
        <Grid item xs={12}>
          <MDButton
            type="button"
            color="primary"
            size="medium"
            variant="outlined"
            sx={{ minWidth: "120px", fontSize: "14px" }}
            onClick={handleDelivery}
          >
            <Icon>add</Icon>&nbsp;Add
          </MDButton>
        </Grid>
      </Grid>
    </AccordionDetails>
  </Accordion>
  )
}

export default FavDeliverySection